module.exports = [{
      plugin: require('C:/Source/Personal/pluto/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
